<div class="main-container">
  <div class="main-page">
    <div class="prospect-detail">
      <div class="white-card">
        <div class="header-title-row">
          <div class="header-left">
            <img
              src="assets/svg/task-icon-orange.svg"
              alt="Prospectos"
              class="center-svg"
            />
            <h1 class="text-semibold color-org t-24">Tareas</h1>
            <div class="dropdown-wrapper" #dropdownContainer>
              <div class="dropdown-trigger" (click)="toggleRecentDropdown()">
                <span>
                  {{ selectedItem === 'todas' ? 'Ver todas las tareas' :
                  selectedItem === 'delDia' ? 'Ver tareas del día' :
                  selectedItem === 'progreso' ? 'Ver tareas en progreso' :
                  selectedItem === 'atrasadas' ? 'Ver tareas atrasadas' :
                  selectedItem === 'proximas' ? 'Ver próximas tareas' :
                  selectedItem === 'propias' ? 'Ver mis propias tareas' : '' }}
                </span>
                <span [class.rotated]="showRecentDropdown">▼</span>
                <div class="dropdown-menu" [class.show]="showRecentDropdown">
                  <button
                    class="dropdown-item"
                    [class.selected]="selectedItem === 'todas'"
                    (click)="selectItem('todas'); $event.stopPropagation()"
                  >
                    <span class="check-icon" *ngIf="selectedItem === 'todas'"
                      >✔</span
                    >Ver todas las tareas
                  </button>
                  <button
                    class="dropdown-item"
                    [class.selected]="selectedItem === 'delDia'"
                    (click)="selectItem('delDia'); $event.stopPropagation()"
                  >
                    <span class="check-icon" *ngIf="selectedItem === 'delDia'"
                      >✔</span
                    >
                    Ver tareas del día
                  </button>
                  <button
                    class="dropdown-item"
                    [class.selected]="selectedItem === 'progreso'"
                    (click)="selectItem('progreso'); $event.stopPropagation()"
                  >
                    <span class="check-icon" *ngIf="selectedItem==='progreso'"
                      >✔</span
                    >
                    Ver tareas en progreso
                  </button>
                  <button
                    class="dropdown-item"
                    [class.selected]="selectedItem === 'atrasadas'"
                    (click)="selectItem('atrasadas'); $event.stopPropagation()"
                  >
                    <span class="check-icon" *ngIf="selectedItem==='atrasadas'"
                      >✔</span
                    >
                    Ver tareas atrasadas
                  </button>
                  <button
                    class="dropdown-item"
                    [class.selected]="selectedItem==='proximas'"
                    (click)="selectItem('proximas'); $event.stopPropagation()"
                  >
                    <span class="check-icon" *ngIf="selectedItem==='proximas'"
                      >✔</span
                    >
                    Ver próximas tareas
                  </button>
                  <button
                    class="dropdown-item"
                    [class.selected]="selectedItem==='propias'"
                    (click)="selectItem('propias'); $event.stopPropagation()"
                  >
                    <span class="check-icon" *ngIf="selectedItem==='propias'"
                      >✔</span
                    >
                    Ver mis propias tareas
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="header-actions">
            <button *ngIf="permissionService.hasPermission('Tareas y recordatorios','Crear')" class="action-btn primary" (click)="openMdlNewTask()">
              <img
                src="assets/svg/plus-icon.svg"
                alt="Añadir nuevo"
                width="16"
                height="16"
              />
              Añadir nuevo
            </button>
          </div>
        </div>

        <div
          class="header-stats mt-3"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div class="header-stats mt-3">
            <span
              >{{tareasFiltradas.length}} elementos | Se actualizó hace 2 minutos</span
            >
            <span *ngIf="hasActiveFilters()" class="filter-badge" style="margin-left: 10px;">
              Filtros aplicados
              <button (click)="clearFilters()" class="clear-filters-btn">×</button>
            </span>
          </div>
          <div
            *ngIf="tareasSeleccionadas > 0"
            style="display: flex; align-items: center; gap: 10px"
          >
            <span class="selection-count" style="font-weight: 500">
              {{ tareasSeleccionadas }} Tareas seleccionados
            </span>

            <div class="actions-container" style="position: relative">
              <div (click)="toggleActionsDropdown()" class="actions-dropdown">
                <span>Seleccionar acción</span>
                <span [class.rotated]="showActionsDropdown"></span>
                <img
                  src="assets/svg/arrow-down-black.svg"
                  class="sort-icon"
                  style="width: 12px; height: 12px"
                />
              </div>

              <div *ngIf="showActionsDropdown" class="dropdown-content">
                <a *ngIf="permissionService.hasPermission('Tareas y recordatorios','Eliminar')" (click)="ejecutarAccion('eliminar')" class="dropdown-item"
                  >Eliminar tareas seleccionadas</a
                >
                <a (click)="ejecutarAccion('completar')" class="dropdown-item"
                  >Completar tareas seleccionadas</a
                >
                <a *ngIf="permissionService.hasPermission('Tareas y recordatorios','Editar')" (click)="ejecutarAccion('cambiar')" class="dropdown-item"
                  >Cambiar propietario</a
                >
              </div>
            </div>
          </div>
        </div>

        <div class="content-area mt-5">
          <div *ngIf="errorMessage" class="error-message">{{errorMessage}}</div>
          <div *ngIf="!isLoading && tareas.length > 0">
            <div class="d-grid search-bar-container" style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  width: 100%;
                  gap: 16px;
                ">
              <div class="npt-table-search-bar d-grid" style="flex: 1; min-width: 0">
                <div><img src="assets/svg/search.svg" alt="" /></div>
                <input
                  type="text"
                  class="npt-nav-search"
                  placeholder="Buscar en esta lista..."
                  [(ngModel)]="searchTerm"
                  (input)="onSearchChange()"
                  style="flex: 1; min-width: 0; width: 100%"
                />
              </div>
              <div style="display: flex; gap: 12px; flex-shrink: 0">
                <button
                  class="search-btn"
                  (click)="actualizarTabla()"
                  style="
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    white-space: nowrap;
                  "
                >
                  <img src="assets/svg/reload-icon.svg" alt="Actualizar" />
                  <span>Actualizar</span>
                </button>
                <button
                  *ngIf="permissionService.hasPermission('Tareas y recordatorios','Editar')"
                  class="search-btn"
                  (click)="editarTarea()"
                  style="
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    white-space: nowrap;
                  "
                >
                  <img src="assets/svg/pen-icon.svg" alt="Editar" />
                  <span>Editar</span>
                </button>
                <button
                  class="search-btn"
                  (click)="openFilterModal()"
                  style="
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    white-space: nowrap;
                  "
                >
                  <img src="assets/svg/filtrar-icon.svg" alt="Filtrar" />
                  <span>Filtrar</span>
                </button>
              </div>
            </div>

            <div class="prospectos-table mh-50">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th class="checkbox-column text-center">
                      <img src="assets/svg/checkline-icon.svg" />
                    </th>
                    <th 
                      (click)="sortByColumn('titulo')"
                      [class.sorted]="sortColumn === 'titulo'"
                      class="sortable-header"
                    >
                      Titulo o descripción
                      <span *ngIf="sortColumn === 'titulo'" class="sort-indicator">
                        {{ sortDirection === 'asc' ? '↑' : '↓' }}
                      </span>
                    </th>
                    <th>Tipo de tarea</th>
                    <th 
                      (click)="sortByColumn('fecha_creacion')"
                      [class.sorted]="sortColumn === 'fecha_creacion'"
                      class="sortable-header"
                    >
                      Fecha de creación
                      <span *ngIf="sortColumn === 'fecha_creacion'" class="sort-indicator">
                        {{ sortDirection === 'asc' ? '↑' : '↓' }}
                      </span>
                    </th>
                    <th 
                      (click)="sortByColumn('fecha_vencimiento')"
                      [class.sorted]="sortColumn === 'fecha_vencimiento'"
                      class="sortable-header"
                    >
                      Fecha de vencimiento
                      <span *ngIf="sortColumn === 'fecha_vencimiento'" class="sort-indicator">
                        {{ sortDirection === 'asc' ? '↑' : '↓' }}
                      </span>
                    </th>
                    <th 
                      (click)="sortByColumn('estado')"
                      [class.sorted]="sortColumn === 'estado'"
                      class="sortable-header"
                    >
                      Estado
                      <span *ngIf="sortColumn === 'estado'" class="sort-indicator">
                        {{ sortDirection === 'asc' ? '↑' : '↓' }}
                      </span>
                    </th>
                    <th>Relacionado con</th>
                    <th 
                      (click)="sortByColumn('prioridad')"
                      [class.sorted]="sortColumn === 'prioridad'"
                      class="sortable-header"
                    >
                      Prioridad
                      <span *ngIf="sortColumn === 'prioridad'" class="sort-indicator">
                        {{ sortDirection === 'asc' ? '↑' : '↓' }}
                      </span>
                    </th>
                    <th>Asignada a</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let tarea of tareasFiltradas; let i = index"
                    (click)="verDetalleTarea(tarea.tarea_id, $event)"
                  >
                    <td class="counter-cell">{{ i + 1 }}.</td>
                    <td class="checkbox-column">
                      <input
                        type="checkbox"
                        (change)="onCheckboxChange($event,tarea.tarea_id)"
                      />
                    </td>
                    <td>
                      <span class="color-org text-semibold"
                        >{{ tarea.titulo }}</span
                      >
                    </td>
                    <td class="tipo-tarea-cell">
                      <div class="tipo-wrapper">
                        <img
                          [src]="getTaskIcon(tarea.tipo)"
                          [alt]="tarea.tipo"
                          width="16"
                          height="16"
                        />
                        <span>{{ tarea.tipo }}</span>
                      </div>
                    </td>
                    <td>
                      {{ tarea.fecha_creacion | date:'dd/MM/yyyy HH:mm' }} hrs.
                    </td>
                    <td>
                      {{ tarea.fecha_vencimiento | date:'dd/MM/yyyy'}} {{
                      tarea.hora_vencimiento}} hrs.
                    </td>

                    <td class="text-center">
                      <span
                        [ngClass]="{
                          'status-completada': tarea.estado === 'Completada',
                          'status-pendiente': tarea.estado === 'Pendiente',
                          'status-enprogreso': tarea.estado === 'En progreso',
                          'status-vencida': tarea.estado === 'Vencida',
                          'status-realizada': tarea.estado === 'Realizada',
                          'status-programada': tarea.estado === 'Programada',
                          'status-cancelada': tarea.estado === 'Cancelada'
                        }"
                      >
                        {{ tarea.estado }}
                      </span>
                    </td>

                    <td class="relacionado-cell">
                      <ng-container [ngSwitch]="tarea.asociado_tipo">
                        <span
                          *ngSwitchCase="'CNT'"
                          class="color-org"
                          [title]="tarea.asociado?.nombre + ' ' + tarea.asociado?.apellido"
                        >
                          <b>Contacto: </b>{{ tarea.asociado?.nombre }} {{
                          tarea.asociado?.apellido }}
                        </span>

                        <span
                          *ngSwitchCase="'ACC'"
                          class="color-org"
                          [title]="tarea.asociado?.nombre_empresa"
                        >
                          <b>Cuenta:</b> {{ tarea.asociado?.nombre_empresa }}
                        </span>

                        <span
                          *ngSwitchCase="'OPP'"
                          class="color-org"
                          [title]="tarea.asociado?.nombre"
                        >
                          <b>Oportunidad:</b> {{ tarea.asociado?.nombre }}
                        </span>

                        <span
                          *ngSwitchCase="'PRO'"
                          class="color-org"
                          [title]="tarea.asociado?.nombre"
                        >
                          <b>Prospecto:</b> {{ tarea.asociado?.nombre }} {{ tarea.asociado?.apellido}}
                        </span>

                        <span *ngSwitchDefault class="color-gray">
                          {{ tarea.asociado_tipo === 'OTRO' ? 'Sin relación
                          específica' : tarea.asociado_tipo }}
                        </span>
                      </ng-container>
                    </td>

                    <td>
                      <span
                        [ngClass]="{
                                    'prioridad-alta': tarea.prioridad === 'Alta',
                                    'prioridad-media': tarea.prioridad === 'Media',
                                    'prioridad-baja': tarea.prioridad === 'Baja'
                                    }"
                      >
                        {{ tarea.prioridad }}
                      </span>
                    </td>
                    <td>
                      <span class="color-org">
                        {{ tarea.ejecutivo?.nombre }} {{
                        tarea.ejecutivo?.apellido }}
                      </span>
                    </td>

                    <td class="actions-cell">
                      <div
                        class="dropdown-container"
                        (click)="$event.stopPropagation()"
                      >
                        <button
                          class="dots-button"
                          (click)="toggleActionsMenu('menu-' + tarea.tarea_id)"
                        >
                          <svg class="dots-icon" viewBox="0 0 24 24">
                            <circle cx="12" cy="5" r="2" />
                            <circle cx="12" cy="12" r="2" />
                            <circle cx="12" cy="19" r="2" />
                          </svg>
                        </button>
                        <div
                          class="dropdown-menu"
                          [class.show]="openedMenuId === 'menu-' + tarea.tarea_id"
                        >
                          <button
                            *ngIf="permissionService.hasPermission('Tareas y recordatorios','Editar')"
                            class="dropdown-item"
                            (click)="openMdlModifyTask(tarea)"
                          >
                            Modificar
                          </button>
                          <button
                            *ngIf="permissionService.hasPermission('Tareas y recordatorios','Eliminar')"
                            class="dropdown-item"
                            (click)="openMdlDeleteTask(tarea)"
                          >
                            Eliminar
                          </button>
                          <button
                            *ngIf="permissionService.hasPermission('Tareas y recordatorios','Cambiar etapa')"
                            class="dropdown-item"
                            (click)="openmdlchangeStatus(tarea)"
                          >
                            Cambiar estado
                          </button>
                          <button
                            *ngIf="permissionService.hasPermission('Tareas y recordatorios','Cambiar etapa')"
                            class="dropdown-item"
                            (click)="openmdlchangePriority(tarea)"
                          >
                            Cambiar prioridad
                          </button>
                          <!-- Agregar esta opción -->
                          <button
                            *ngIf="permissionService.hasPermission('Tareas y recordatorios','Editar')"
                            class="dropdown-item"
                            (click)="cambiarPropietarioIndividual(tarea)"
                          >
                            Cambiar propietario
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            *ngIf="!isLoading && tareas.length === 0 && !errorMessage"
            class="empty-state"
          >
            <div class="empty-content">
              <div class="empty-image">
                <img
                  src="assets/img/listaprospecto.png"
                  alt="Lista de prospectos vacía"
                />
              </div>
              <h2>Sin tareas por ahora</h2>
              <p>
                Todavía no tienes tareas registrados. Puedes comenzar agregando
                una nueva.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>